document.querySelectorAll('[data-product-page]').forEach((productPage) => {
  if (productPage.dataset.productPageLoaded === 'true') return;

  productPage.dataset.productPageLoaded = 'true';

  const quantityInput = productPage.querySelector('.product-page__quantity-input');
  const decreaseButton = productPage.querySelector('[data-quantity-decrease]');
  const increaseButton = productPage.querySelector('[data-quantity-increase]');
  const stockStatus = productPage.querySelector('[data-stock-status]');
  const stockText = productPage.querySelector('[data-stock-text]');

  function getQuantity() {
    if (!quantityInput) return 1;

    return Math.max(parseInt(quantityInput.value, 10) || 1, 1);
  }

  function updateStockStatus(variant) {
    if (!stockStatus || !stockText || !variant) return;

    const isAvailable = Boolean(variant.available);
    const allowsBackorders = variant.inventoryPolicy === 'continue';

    stockStatus.dataset.variantId = variant.variantId || '';
    stockStatus.classList.toggle('is-in-stock', isAvailable);
    stockStatus.classList.toggle('is-out-of-stock', !isAvailable);

    const icon = stockStatus.querySelector('.product-page__stock-icon');

    if (isAvailable) {
      stockText.textContent = 'In Stock';

      if (icon) {
        icon.className =
          'product-page__stock-icon product-page__stock-icon--available';
        icon.textContent = '';
        icon.setAttribute('aria-hidden', 'true');
      }
    } else {
      stockText.textContent = allowsBackorders
        ? 'Available to order'
        : '0 Stock';

      if (icon) {
        icon.className =
          'product-page__stock-icon product-page__stock-icon--sold-out';
        icon.textContent = '×';
        icon.setAttribute('aria-hidden', 'true');
      }
    }
  }

  decreaseButton?.addEventListener('click', () => {
    if (!quantityInput) return;

    quantityInput.value = Math.max(getQuantity() - 1, 1);
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  });

  increaseButton?.addEventListener('click', () => {
    if (!quantityInput) return;

    quantityInput.value = getQuantity() + 1;
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  });

  quantityInput?.addEventListener('change', () => {
    quantityInput.value = getQuantity();
  });

  productPage.addEventListener('variant:change', (event) => {
    const detail = event.detail;

    if (!detail?.variantId) return;

    updateStockStatus({
      variantId: detail.variantId,
      available: detail.available,
      inventoryPolicy: detail.inventoryPolicy,
    });
  });
});